import { combineReducers } from "redux";
import { reducer as toastrReducer } from "react-redux-toastr";

import UsuarioReducer from "./usuario/usuarioReducer";
import ConcursoReducer from "./concurso/concursoReducer";
import ConcursosReducer from "./concursos/concursosReducer";
import CarrinhoReducer from "./carrinho/carrinhoReducer";
import SuasApostasReducer from "./relatorios/suasapostasReducer";
import LoteriaReducer from "./loteria/loteriaReducer";
import ModalidadeInputReducer from "./modalidade/modalidadeInputReducer";
import ResultadosReducer from "./relatorios/resultadosReducer";
import ExtracoesReducer from "./relatorios/extracoesReducer";
import RepeticaoReducer from "./repeticao/repeticaoReducer";
import SettingsReducer from "./settings/settingsReducer";
import RifaReducer from "./rifa/rifaReducer";
import AnalyticsReducer from "./analytics/analyticsReducer";

const rootReducer = combineReducers({
  settings: SettingsReducer,
  usuario: UsuarioReducer,
  concurso: ConcursoReducer,
  concursos: ConcursosReducer,
  carrinho: CarrinhoReducer,
  suasapostas: SuasApostasReducer,
  resultados: ResultadosReducer,
  extracoes: ExtracoesReducer,
  toastr: toastrReducer,
  loteria: LoteriaReducer,
  modalidadeInput: ModalidadeInputReducer,
  repeticao: RepeticaoReducer,
  rifa: RifaReducer,
  ga_utilities: AnalyticsReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/reducers.js